import * as React from "react";
import Flexbox from "flexbox-react";
import { InputGroup, Button, Tooltip, Position, Checkbox, Icon } from "@blueprintjs/core";
import Pagination from "react-js-pagination";
import axios from "axios";
import Cookies from "js-cookie";
import ThemeWrapper from "../components/styles/ThemeWrapper/index.js";
import ErrorBoundary from "../components/errors/ErrorBoundary";
import Utilities from "../utils/Utilities";
import ScrollableDropdown from "../components/shared/ScrollableDropdown";
import ToastStore from "../stores/ToastStore";
import CurrentUserStore from '../stores/CurrentUserStore.js';
import FilledButton from "../components/buttons-20250224T111359Z-001/buttons/FilledButton.jsx";
import ConfirmationDialog from "./ConfirmationDialog.js";
import "../css/performanceAndScroll.css";
import PerformanceTableInfoCard from "../components/goal_performance/PerformanceTableInfoCard";
import "../components/goal_performance/UsersPerformanceViewTable.css";

export const GOAL_PROGRESS_SPECIAL_ACCOUNT_ID = "adad3a40-d28f-4dd3-8570-7a213b6cc4c7";
// const GOAL_PROGRESS_SPECIAL_ACCOUNT_ID = "e9570019-f65a-40f9-838a-b2e31754f6ed";

export default class UsersPerformanceViewTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            searchQuery: "",
            usersPerformanceReview: [],
            isLoadingUsersPerformanceReview: false,
            hasLoadedUsersPerformanceReview: false,
            error: null,
            currentPage: 1,
            perPage: 10,
            totalUsersPerformanceReviewCount: 0,
            totalUsersPerformanceReviewPages: 0,
            goalCycleList: [],
            selectedTimeframe: {},
            isLoadingCycles: false,
            filters: {
                performanceCycle: "all",
                state: "all",
                name: "all"
            },
            sendingReminderUserId: null,
            selectedUsers: new Set(),
            isSendingReminderAll: false,
            releasingUserId: null,

            managerList: [],
            selectedManager: null,
            isLoadingManagers: false,

            profiles: [],
            selectedProfile: null,
            isLoadingProfiles: false,
            showReleaseConfirm: false,
            releaseTargetUserId: null,
            showReminderConfirm: false,
            reminderTargetUserId: null,
            accountId: null,
            performanceInfoCards: [],
            totalUsers: 0,
            showAllPerformanceCards: false,
        };
    }

    openReleaseConfirm = (userId) => {
        this.setState({
            showReleaseConfirm: true,
            releaseTargetUserId: userId,
        });
    };

    closeReleaseConfirm = () => {
        this.setState({
            showReleaseConfirm: false,
            releaseTargetUserId: null,
        });
    };

    openReminderConfirm = (userId) => {
        this.setState({
            showReminderConfirm: true,
            reminderTargetUserId: userId,
        });
    };

    closeReminderConfirm = () => {
        this.setState({
            showReminderConfirm: false,
            reminderTargetUserId: null,
        });
    };


    getManagerUserId = () => {
        return (
            this.state?.selectedManager?.id ||
            CurrentUserStore?.currentUser?.id ||
            null
        );
    };

    handleRowClick = (row) => {
        const userId = row.userId;
        const userName = row.name;
        const managerId = row.managerId;
        const goalSettingId = this.state.selectedTimeframe?.id;

        if (!userId || !goalSettingId) {
            ToastStore.showToast("Missing user or goal cycle", "danger");
            return;
        }

        const payload = {
            u: userId,
            g: goalSettingId,
            m: managerId,
            n: userName
        };

        sessionStorage.setItem(
            "team_review_context",
            JSON.stringify(payload)
        );

        Utilities.navigate(
            `/performance/team/review?r=${encodeURIComponent(
                btoa(JSON.stringify(payload))
            )}`
        );
    };

    updateAccountId = () => {
        const accountId = CurrentUserStore?.activeAccount?.accountId;

        if (accountId && this.state.accountId !== accountId) {

            this.setState({ accountId });
        }
    };

    componentDidMount() {
        this.fetchJobProfiles();

        Promise.all([
            this.getAllGoalCycleList(),
            this.getManagerList()
        ])
            .then(() => {
                this.fetchUsersPerformanceReview();
                this.fetchPerformanceInfoCards();
            })
            .catch(err => {
                console.error("Failed to load goal cycles or manager list", err);
            });

        // Try once (may or may not be available)
        this.updateAccountId();

        // =========================
        // Horizontal scroll with mouse wheel
        // =========================
        setTimeout(() => {
            const tableScroll = document.querySelector(".performance-table-scroll");

            if (tableScroll) {
                tableScroll.addEventListener(
                    "wheel",
                    (e) => {
                        const isHorizontalScrollable =
                            tableScroll.scrollWidth > tableScroll.clientWidth;

                        if (!isHorizontalScrollable) return;

                        // vertical mouse wheel => horizontal scroll
                        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
                            e.preventDefault();
                            tableScroll.scrollLeft += e.deltaY;
                        }
                    },
                    { passive: false }
                );
            }
        }, 100);
    }

    componentDidUpdate(prevProps, prevState) {
        const accountId = CurrentUserStore?.activeAccount?.accountId;

        if (accountId && prevState.accountId !== accountId) {
            this.setState({ accountId });
        }

        const prevGoalSettingId = prevProps.goalSettingId || prevProps.goal_setting_id;
        const currentGoalSettingId = this.props.goalSettingId || this.props.goal_setting_id;

        if (prevGoalSettingId !== currentGoalSettingId) {
            this.setState(
                { currentPage: 1 },
                () => this.fetchUsersPerformanceReview(1, this.state.perPage)
            );
        }
    }

    getManagerList = (search = "") => {
        this.setState({ isLoadingManagers: true });
        return axios
            .get(`${Cookies.get("apiEnv")}/review_workflows/manager_list`, {
                params: search ? { search } : {}
            })
            .then(res => {
                const list = res?.data || [];

                this.setState(prev => ({
                    managerList: list,
                    selectedManager: prev.selectedManager || list[0] || null,
                    isLoadingManagers: false
                }), () => {
                    if (!search) this.fetchUsersPerformanceReview(1, this.state.perPage);
                });
            })
            .catch(() => {
                this.setState({ managerList: [], isLoadingManagers: false });
            });
    };

    getManagerList = (search = "") => {
        this.setState({ isLoadingManagers: true });
        return axios
            .get(`${Cookies.get("apiEnv")}/review_workflows/manager_list`, {
                params: search ? { search } : {}
            })
            .then(res => {
                const list = (res?.data || []).map(manager => ({
                    ...manager,
                    fullName: manager.first_name && manager.last_name
                        ? `${manager.first_name} ${manager.last_name}`
                        : (manager.first_name || manager.last_name || manager.email || "Unknown")
                }));

                this.setState(prev => ({
                    managerList: list,
                    selectedManager: prev.selectedManager || list[0] || null,
                    isLoadingManagers: false
                }), () => {
                    if (!search) this.fetchUsersPerformanceReview(1, this.state.perPage);
                });
            })
            .catch(() => {
                this.setState({ managerList: [], isLoadingManagers: false });
            });
    };


    getAllGoalCycleList = () => {
        this.setState({ isLoadingCycles: true });

        return new Promise((resolve, reject) => {
            axios
                .get(`${Cookies.get("apiEnv")}/goal_settings/goal_cycle_list`)
                .then(response => {
                    const goalCycleList = response.data || [];

                    if (goalCycleList.length > 0) {
                        this.setState(
                            {
                                goalCycleList,
                                selectedTimeframe: goalCycleList[0],
                                isLoadingCycles: false
                            },
                            resolve
                        );
                    } else {
                        this.setState(
                            { goalCycleList: [], selectedTimeframe: {}, isLoadingCycles: false },
                            resolve
                        );
                    }
                })
                .catch(error => {
                    this.setState({ error: "Failed to load", isLoadingCycles: false });
                    reject(error);
                });
        });
    };

    fetchJobProfiles = async () => {
        const baseUrl = Cookies.get('apiEnv');
        if (!baseUrl) return;

        this.setState({ isLoadingProfiles: true });
        try {
            const response = await axios.get(`${baseUrl}/job_profiles`);
            const profiles = Array.isArray(response.data) ? response.data : [];

            // Add "All profiles" option that doesn't send any job_profile_id
            const profilesWithAll = [
                { id: null, name: "All Job Profiles" },
                ...profiles
            ];

            // this.setState({ profiles: profilesWithAll });
            this.setState({
                profiles: profilesWithAll,
                selectedProfile: profilesWithAll[0]
            });
        } catch (e) {
            const message =
                e?.response?.data?.error?.join?.(', ') ||
                e?.response?.data?.error ||
                'Unable to load job profiles';
            ToastStore?.showToast?.(message, 'danger');
        } finally {
            this.setState({ isLoadingProfiles: false });
        }
    };

    fetchPerformanceInfoCards = () => {
        const { selectedTimeframe, selectedProfile } = this.state;
        if (!selectedTimeframe?.id) return;

        const payload = {
            goal_setting_id: selectedTimeframe.id,
            ...(selectedProfile?.id ? { job_profile_id: selectedProfile.id } : {})
        };
        axios.post(`${Cookies.get("apiEnv")}/insights_report/team_header_report`, payload)
            .then(response => {
                const processedData = response.data?.data?.map(item => ({
                    completed: item.completed_count || 0,
                    notCompleted: item.not_completed_count || 0,
                    position: item.position || 0,
                    id: item.step_id || "",
                    title: item.step_name || "",
                    total: item.total_users || 0,
                    type: item.step_type || ""
                }));
                this.setState({ performanceInfoCards: processedData, totalUsers: response?.data?.total_users || 0 });
            })
            .catch(error => {
                console.error(
                    "Failed to load performance info cards",
                    error
                );
            });
    };

    fetchUsersPerformanceReview = (page = this.state.currentPage, perPage = this.state.perPage) => {
        const { selectedTimeframe, filters, searchQuery, selectedProfile } = this.state;

        if (!selectedTimeframe || !selectedTimeframe.id) return;

        this.setState({ isLoadingUsersPerformanceReview: true, hasLoadedUsersPerformanceReview: false });

        const stateParam = filters?.state && filters.state !== "all" ? filters.state : undefined;
        const searchParam =
            searchQuery && searchQuery.trim().length > 0
                ? searchQuery.trim()
                : undefined;

        if (this.currentReviewWorkflowsRequest && typeof this.currentReviewWorkflowsRequest.cancel === "function") {
            this.currentReviewWorkflowsRequest.cancel("Cancelled due to new request.");
        }
        this.currentReviewWorkflowsRequest = axios.CancelToken.source();

        const params = {
            goal_setting_id: selectedTimeframe.id,
            ...(selectedProfile?.id ? { job_profile_id: selectedProfile.id } : {}),
            page,
            per_page: perPage,
            ...(stateParam ? { state: stateParam } : {}),
            ...(searchParam ? { search: searchParam } : {}),
        };

        axios.get(
            `${Cookies.get("apiEnv")}/review_workflows`,
            {
                params,
                cancelToken: this.currentReviewWorkflowsRequest.token
            }
        )
            .then(response => {
                const apiData = response?.data || {};
                const usersPerformanceReviewData = apiData?.data || [];

                const usersPerformanceReview = usersPerformanceReviewData?.map(item => {
                    const formatStatus = status => {
                        if (!status && status !== 0) return "-";
                        return String(status)
                            .replace(/_/g, " ")
                            .replace(/\b\w/g, c => c.toUpperCase());
                    };

                    const normalizeRating = rating =>
                        rating === null || rating === undefined || rating === ""
                            ? "-"
                            : rating;

                    const overallState = item?.overall_state || item?.overallState || item?.overall_status || "";
                    const isReleased = String(overallState).toLowerCase() === "released";

                    const userId = item?.user_id || item?.user?.id || item?.id;
                    return {
                        id: userId,
                        userId,
                        name: item?.user_name || item?.user?.fullName || item?.email || "",
                        email: item?.email || "",
                        managerId: null,
                        reviewState: formatStatus(overallState),
                        overallState,
                        performanceCycle: "",
                        steps: Array.isArray(item?.steps)
                            ? item.steps.map(step => ({
                                ...step,
                                state: formatStatus(step?.state),
                                rating: normalizeRating(step?.rating)
                            }))
                            : [],
                        lastReminderSentAt: null,
                        isReleased,
                        mailSent: false
                    };
                });

                const meta = apiData?.meta || {};
                const totalCount = Number.isFinite(meta.total_count) ? meta.total_count : usersPerformanceReview.length;
                const perPageValue = Number.isFinite(meta.per_page) ? meta.per_page : perPage;
                const currentPageValue = Number.isFinite(meta.page) ? meta.page : page;
                const totalPages =
                    Number.isFinite(meta.total_pages) && meta.total_pages > 0
                        ? meta.total_pages
                        : perPageValue > 0
                            ? Math.max(1, Math.ceil(totalCount / perPageValue))
                            : 1;

                this.setState({
                    usersPerformanceReview,
                    isLoadingUsersPerformanceReview: false,
                    hasLoadedUsersPerformanceReview: true,
                    error: null,
                    totalUsersPerformanceReviewCount: totalCount,
                    totalUsersPerformanceReviewPages: totalPages,
                    currentPage: currentPageValue,
                    perPage: perPageValue
                });
            })
            .catch(error => {
                console.error("Failed to load review workflows", error);
                this.setState({
                    error: "Failed to load review workflows",
                    usersPerformanceReview: [],
                    isLoadingUsersPerformanceReview: false,
                    hasLoadedUsersPerformanceReview: true,
                    totalUsersPerformanceReviewCount: 0,
                    totalUsersPerformanceReviewPages: 0
                });
            });
    };

    getStepColumns = () => {
        const { usersPerformanceReview } = this.state;
        if (!Array.isArray(usersPerformanceReview) || usersPerformanceReview.length === 0) {
            return [];
        }

        const stepMap = new Map();
        usersPerformanceReview.forEach(row => {
            (row.steps || []).forEach(step => {
                const key = step.step_id || step.step_name || step.name;
                if (!key) return;
                const existing = stepMap.get(key);
                if (!existing || (step.position || 0) < (existing.position || 0)) {
                    stepMap.set(key, step);
                }
            });
        });

        return Array.from(stepMap.values()).sort((a, b) => (a.position || 0) - (b.position || 0));
    };

    formatStatus = status => {
        if (!status && status !== 0) return "-";
        return String(status)
            .replace(/_/g, " ")
            .replace(/\b\w/g, c => c.toUpperCase());
    };

    normalizeRating = rating =>
        rating === null || rating === undefined || rating === ""
            ? "-"
            : rating;

    handleSelectGoalCycle = timeframe => {
        this.setState(
            {
                selectedTimeframe: timeframe,
                currentPage: 1,
                filters: {
                    ...this.state.filters,
                    performanceCycle: "all"
                }
            },
            () => {
                this.fetchUsersPerformanceReview(1, this.state.perPage);
                this.fetchPerformanceInfoCards();
            }
        );
    };

    handleSelectProfile = profile => {
        this.setState({ selectedProfile: profile }, () => {
            this.fetchUsersPerformanceReview(1, this.state.perPage);
            this.fetchPerformanceInfoCards();
        });

    };

    handleUsersPerformanceReviewPageChange = pageNumber => {
        this.setState(
            {
                currentPage: pageNumber
            },
            () => this.fetchUsersPerformanceReview(pageNumber, this.state.perPage)
        );
    };

    handleSendReminder = userId => {
        const { selectedTimeframe } = this.state;

        if (!userId || !selectedTimeframe?.id) {
            ToastStore.showToast("Missing user or goal cycle", "warning");
            return;
        }

        this.setState({ sendingReminderUserId: userId });

        axios
            .post(`${Cookies.get("apiEnv")}/review_workflows/send_reminder`, {
                user_id: userId,
                goal_setting_id: selectedTimeframe?.id
            })
            .then(res => {
                const message = res?.data?.message || "Reminder sent";
                ToastStore.showToast(message, "success");
                this.setState(prevState => ({
                    usersPerformanceReview: prevState.usersPerformanceReview.map(item =>
                        item.userId === userId
                            ? { ...item, lastReminderSentAt: new Date().toISOString() }
                            : item
                    )
                }));
            })
            .catch(error => {
                const message = error?.response?.data?.message || "Failed to send reminder";
                ToastStore.showToast(message, "danger");
            })
            .finally(() => {
                this.setState({ sendingReminderUserId: null });
            });
    };

    handlePerPageChange = event => {
        const perPage = parseInt(event.target.value, 10) || 10;
        this.setState(
            {
                perPage,
                currentPage: 1
            },
            () => this.fetchUsersPerformanceReview(1, perPage)
        );
    };

    handleSearchChange = e => {
        const value = e.target.value;

        this.setState({ searchQuery: value });

        clearTimeout(this.searchDebounce);
        this.searchDebounce = setTimeout(() => {
            this.setState({ currentPage: 1 }, () =>
                this.fetchUsersPerformanceReview(1, this.state.perPage)
            );
        }, 400);
    };

    handleSelectUser = (userId, isChecked) => {
        this.setState(prevState => {
            const newSelectedUsers = new Set(prevState.selectedUsers);
            if (isChecked) {
                newSelectedUsers.add(userId);
            } else {
                newSelectedUsers.delete(userId);
            }
            return { selectedUsers: newSelectedUsers };
        });
    };

    handleSelectAll = async isChecked => {
        const { selectedTimeframe, filters, searchQuery, selectedProfile } = this.state;

        if (!isChecked) {
            this.setState({ selectedUsers: new Set() });
            return;
        }

        if (!selectedTimeframe?.id) {
            ToastStore.showToast("Please select a goal cycle", "warning");
            return;
        }

        const stateParam = filters?.state && filters.state !== "all" ? filters.state : undefined;
        const searchParam =
            searchQuery && searchQuery.trim().length > 0
                ? searchQuery.trim()
                : undefined;

        try {
            const response = await axios.get(`${Cookies.get("apiEnv")}/review_workflows`, {
                params: {
                    goal_setting_id: selectedTimeframe.id,
                    page: 1,
                    per_page: 10000,
                    ...(stateParam ? { state: stateParam } : {}),
                    ...(searchParam ? { search: searchParam } : {}),
                    ...(selectedProfile?.id ? { job_profile_id: selectedProfile.id } : {})
                }
            });

            const apiData = response?.data || {};
            const usersPerformanceReviewData = apiData?.data || [];
            const allUserIds = usersPerformanceReviewData
                .map(item => item.user_id || item.user?.id || item.user?.humanFriendlyId)
                .filter(Boolean);

            this.setState({
                selectedUsers: new Set(allUserIds)
            });
        } catch (error) {
            console.error("Failed to fetch all users for select all", error);
            const { filteredUsersPerformanceReview } = this.getFilteredData();
            this.setState({
                selectedUsers: new Set(filteredUsersPerformanceReview.map(item => item.userId).filter(Boolean))
            });
        }
    };

    getFilteredData = () => {
        const { usersPerformanceReview, filters } = this.state;
        const filteredUsersPerformanceReview = usersPerformanceReview
            .filter(usersPerformanceReviewItem =>
                filters.performanceCycle === "all" ? true : usersPerformanceReviewItem.performanceCycle === filters.performanceCycle
            )
            .filter(usersPerformanceReviewItem => (filters.name === "all" ? true : usersPerformanceReviewItem.name === filters.name));
        return { filteredUsersPerformanceReview };
    };

    handleSendReminderAll = async () => {
        const { selectedUsers, selectedTimeframe } = this.state;

        if (selectedUsers.size === 0) {
            ToastStore.showToast("Please select at least one user", "warning");
            return;
        }
        if (!selectedTimeframe?.id) {
            ToastStore.showToast("Please select a goal cycle", "warning");
            return;
        }

        this.setState({ isSendingReminderAll: true });

        const userIds = Array.from(selectedUsers);
        let successCount = 0;
        let failCount = 0;

        for (const userId of userIds) {
            try {
                await axios.post(`${Cookies.get("apiEnv")}/review_workflows/send_reminder`, {
                    user_id: userId,
                    goal_setting_id: selectedTimeframe.id
                });
                successCount++;
            } catch (error) {
                console.error(`Failed to send reminder to user ${userId}:`, error);
                failCount++;
            }
        }

        if (successCount > 0) {
            ToastStore.showToast(
                `Reminders sent to ${successCount} user${successCount > 1 ? "s" : ""}${failCount > 0 ? `, ${failCount} failed` : ""}`,
                failCount > 0 ? "warning" : "success"
            );
            this.fetchUsersPerformanceReview(this.state.currentPage, this.state.perPage);
        } else {
            ToastStore.showToast("Failed to send reminders", "danger");
        }

        this.setState({ isSendingReminderAll: false, selectedUsers: new Set() });
    };

    handleRelease = userId => {
        const { selectedTimeframe, usersPerformanceReview } = this.state;

        const row = usersPerformanceReview.find(u => u.userId === userId);

        if (row?.isReleased) {
            return;
        }

        if (!userId || !selectedTimeframe?.id) {
            ToastStore.showToast("Missing user or goal cycle", "warning");
            return;
        }

        this.setState({ releasingUserId: userId });

        axios
            .post(`${Cookies.get("apiEnv")}/review_workflows/publish`, {
                user_id: userId,
                goal_setting_id: selectedTimeframe.id
            })
            .then(res => {
                const message = res?.data?.message || "Released successfully";
                ToastStore.showToast(message, "success");
                this.fetchUsersPerformanceReview();

                this.setState(prevState => ({
                    usersPerformanceReview: prevState.usersPerformanceReview.map(item =>
                        item.userId === userId
                            ? {
                                ...item,
                                isReleased: true,
                                state: "Released"
                            }
                            : item
                    )
                }));
            })
            .catch(error => {
                const message =
                    error?.response?.data?.message || "Failed to release";
                ToastStore.showToast(message, "danger");
            })
            .finally(() => {
                this.setState({ releasingUserId: null });
            });
    };

    getRatingLabel = (label) => {
        if (!label) return "-";

        if (typeof label === "object") {
            return label.label || label.value || "-";
        }

        return String(label);
    };


    render() {
        const {
            searchQuery,
            usersPerformanceReview,
            filters,
            isLoadingUsersPerformanceReview,
            goalCycleList,
            selectedTimeframe,
            currentPage,
            perPage,
            totalUsersPerformanceReviewCount,
            totalUsersPerformanceReviewPages,
            sendingReminderUserId,
            selectedUsers,
            isSendingReminderAll,
            releasingUserId,
            performanceInfoCards,
            totalUsers,
            hasLoadedUsersPerformanceReview
        } = this.state;

        const isSpecialAccount =
            this.state.accountId === GOAL_PROGRESS_SPECIAL_ACCOUNT_ID;

        const STATE_FILTERS = {
            all: "All",
            pending: "Pending",
            in_progress: "In Progress",
            completed: "Completed"
        };

        const canReleaseReview = CurrentUserStore.userIsAccountOwner === true;
        const stepColumns = this.getStepColumns();
        // Column count: Employee Name + Steps (only if present) + Overall Status + Release Review (if allowed)
        const tableColumnCount = 2 + stepColumns.length + (canReleaseReview ? 1 : 0);
        const stateOptions = Object.entries(STATE_FILTERS).map(([id, title]) => ({
            id,
            title
        }));

        const { filteredUsersPerformanceReview } = this.getFilteredData();
        const validItems = filteredUsersPerformanceReview.filter(item => item.userId);
        const selectedCount = validItems.filter(item => selectedUsers.has(item.userId)).length;
        const totalValidItems = validItems.length;
        const allSelected = totalValidItems > 0 && selectedCount === totalValidItems;
        const showTableLoader = isLoadingUsersPerformanceReview || !selectedTimeframe?.id;
        const showNoDataState = !showTableLoader && hasLoadedUsersPerformanceReview && filteredUsersPerformanceReview.length === 0;

        return (
            <ThemeWrapper>
                <ErrorBoundary>
                    <Flexbox
                        className="users-performance-overview"
                        flexDirection="column"
                        padding="20px"
                        marginLeft="10px"
                        style={{ width: "100%", maxWidth: "100%", minWidth: 0, boxSizing: "border-box" }}
                    >
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                width: "100%",
                                maxWidth: "100%",
                                minWidth: 0,
                                flexWrap: "wrap",
                                gap: "12px",
                                marginTop: "32px",
                                marginBottom: "20px",
                                position: "relative",
                                // zIndex: 20,
                                boxSizing: "border-box"
                            }}
                        >
                            <h3 style={{ fontSize: "20px", margin: 0 }}>Employees Performance Overview</h3>
                            <Flexbox
                                flexWrap="wrap"
                                justifyContent="flex-end"
                                alignItems="center"
                                style={{
                                    gap: "12px",
                                    // zIndex: 20,
                                    position: "relative",
                                    minWidth: 0,
                                    flex: "1 1 280px",
                                    boxSizing: "border-box"
                                }}
                            >
                                <div style={{ width: "250px" }}>
                                    <ScrollableDropdown
                                        width={250}
                                        label={selectedTimeframe?.title || "Goal Cycle"}
                                        items={goalCycleList}
                                        getKey={g => g.id}
                                        getLabel={g => g.title}
                                        enableSearch
                                        onSelect={this.handleSelectGoalCycle}
                                    />
                                </div>
                                <div style={{ width: "250px" }}>
                                    <ScrollableDropdown
                                        width={250}
                                        label={
                                            this.state.selectedProfile?.name
                                            || "Select Job Profile"}
                                        items={this.state.profiles}
                                        getKey={p => p.id}
                                        getLabel={p => p.name}
                                        enableSearch
                                        onSelect={this.handleSelectProfile}
                                        isLoading={this.state.isLoadingProfiles}
                                    />
                                </div>

                                <div style={{ width: "220px" }}>
                                    <ScrollableDropdown
                                        width={220}
                                        label={stateOptions.find(opt => opt.id === filters.state)?.title || "By State"}
                                        items={stateOptions}
                                        getKey={item => item.id}
                                        getLabel={item => item.title}
                                        enableSearch
                                        onSelect={item =>
                                            this.setState(
                                                {
                                                    filters: { ...filters, state: item.id },
                                                    currentPage: 1
                                                },
                                                () => this.fetchUsersPerformanceReview(1, this.state.perPage)
                                            )
                                        }
                                    />
                                </div>

                                <div style={{ width: "220px" }}>
                                    <InputGroup
                                        leftIcon="search"
                                        placeholder="Search by users name..."
                                        value={searchQuery}
                                        large={true}
                                        onChange={this.handleSearchChange}
                                        style={{
                                            width: "100%",
                                            borderRadius: "20px",
                                            fontSize: "14px"
                                        }}
                                        inputProps={{
                                            style: {
                                                borderRadius: "20px"
                                            }
                                        }}
                                    />
                                </div>

                            </Flexbox>
                        </div>

                        {performanceInfoCards.length > 0 && (
                            <>
                                <Flexbox alignItems="center" justifyContent="flex-start" >
                                    <span style={{ color: "#4d4d4d", marginBottom: "0px" }} >Total Employees</span>
                                    <span style={{ fontWeight: 600, marginLeft: "10px" }}>{totalUsers}</span>
                                </Flexbox>
                            </>
                        )}

                        <div className="users-performance-summary">
                            <div className="users-performance-summary-cards">
                                {performanceInfoCards.map(card => (
                                    <PerformanceTableInfoCard
                                        key={card.id}
                                        card={card}
                                    />
                                ))}
                            </div>
                        </div>

                        <div
                            className="push-20-t performance-table-card"
                            style={{ marginTop: "20px", flexShrink: 0, width: "100%" }}
                        >
                            <div className="performance-table-scroll u-hide-scrollbar-x">
                                <table className="performance-table">
                                    <thead
                                        style={{
                                            backgroundColor: "rgba(189, 195, 199, 0.10)",
                                            color: "#4D4D4D"
                                        }}
                                    >
                                        <tr
                                            style={{
                                                alignContent: "center",
                                                fontSize: "18px",
                                                lineHeight: "normal"
                                            }}
                                        >
                                            <th
                                                className="table-header-text"
                                                style={{ width: "16%", padding: "12px 12px", minWidth: "200px" }}
                                            >
                                                Employee Name
                                            </th>
                                            {stepColumns.length > 0 && (
                                                stepColumns.map(step => (
                                                    <th
                                                        key={step.step_id || step.step_name || step.name}
                                                        className="table-header-text"
                                                        style={{ textAlign: "center", padding: "12px 12px", minWidth: "180px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                                                        title={step.step_name || step.name || "Step"}
                                                    >
                                                        {step.step_name || step.name || "Step"}
                                                    </th>
                                                ))
                                            )}
                                            <th
                                                className="table-header-text"
                                                style={{ width: "13%", textAlign: "center", padding: "12px 12px", minWidth: "140px" }}
                                            >
                                                Overall Status
                                            </th>
                                            {/* <th
                                            className="table-header-text"
                                            style={{ width: "7.5%", textAlign: "center", padding: "12px 12px" }}
                                        >
                                            Send Reminder
                                        </th> */}
                                            {canReleaseReview && (
                                                <th
                                                    className="table-header-text"
                                                    style={{ width: "7.5%", textAlign: "center", padding: "12px 12px", minWidth: "120px" }}
                                                >
                                                    Release Review
                                                </th>
                                            )}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {showTableLoader ? (
                                            <tr>
                                                <td
                                                    className="table-header-text"
                                                    colSpan={tableColumnCount}
                                                    style={{ textAlign: "center", padding: "16px" }}
                                                >
                                                    <img
                                                        style={{ height: '35px', width: '35px' }}
                                                        src="https://s01.live2support.com/dashboardv2/chatassets/img/loader_new.gif"
                                                        alt="Loading..."
                                                    />
                                                </td>
                                            </tr>
                                        ) : showNoDataState ? (
                                            <tr>
                                                <td
                                                    className="table-header-text"
                                                    colSpan={tableColumnCount}
                                                    style={{ textAlign: "center", padding: "16px" }}
                                                >
                                                    No data found
                                                </td>
                                            </tr>
                                        ) : (
                                            filteredUsersPerformanceReview?.map((usersPerformanceReviewRow, index) => (
                                                <tr
                                                    className="table-row"
                                                    key={usersPerformanceReviewRow.userId || usersPerformanceReviewRow.id || `row-${index}`}
                                                    onClick={() => this.handleRowClick(usersPerformanceReviewRow)}
                                                    style={{
                                                        cursor: "pointer",
                                                        alignContent: "center",
                                                        height: "60px",
                                                        verticalAlign: "middle"
                                                    }}
                                                >
                                                    <td
                                                        className="table-header-text"
                                                        style={{ verticalAlign: "middle" }}
                                                    >
                                                        <Flexbox alignItems="center">
                                                            <div
                                                                style={{
                                                                    width: 32,
                                                                    height: 32,
                                                                    borderRadius: "50%",
                                                                    backgroundColor: "#e6f0ff",
                                                                    color: "#2f5ee0",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    fontSize: 12,
                                                                    marginRight: 8,
                                                                    position: "relative",
                                                                    flexShrink: 0
                                                                }}
                                                            >
                                                                {usersPerformanceReviewRow.imageFileName && (
                                                                    <img
                                                                        src={usersPerformanceReviewRow.imageFileName}
                                                                        alt={usersPerformanceReviewRow.name}
                                                                        loading="lazy"
                                                                        onError={e => {
                                                                            e.target.onerror = null;
                                                                            e.target.style.display = "none";
                                                                        }}
                                                                        style={{
                                                                            position: "absolute",
                                                                            top: 0,
                                                                            left: 0,
                                                                            width: 32,
                                                                            height: 32,
                                                                            borderRadius: "50%",
                                                                            objectFit: "cover"
                                                                        }}
                                                                    />
                                                                )}
                                                                <span
                                                                    style={{
                                                                        position: usersPerformanceReviewRow.imageFileName ? "absolute" : "relative",
                                                                        visibility: usersPerformanceReviewRow.imageFileName ? "hidden" : "visible"
                                                                    }}
                                                                >
                                                                    {usersPerformanceReviewRow.name
                                                                        .split(" ")
                                                                        .filter(Boolean)
                                                                        .map(part => part[0])
                                                                        .join("")
                                                                        .substring(0, 2)
                                                                        .toUpperCase()}
                                                                </span>
                                                            </div>
                                                            <Tooltip portalContainer={document.body}
                                                                content={usersPerformanceReviewRow.name}
                                                                position={Position.TOP}
                                                                hoverOpenDelay={300}
                                                                boundary="viewport"
                                                                className="custom-bp-tooltip"
                                                            >
                                                                <span
                                                                    className="ellipsis-text"
                                                                    style={{ cursor: "pointer" }}
                                                                >
                                                                    {usersPerformanceReviewRow.name}
                                                                </span>
                                                            </Tooltip>
                                                        </Flexbox>
                                                    </td>
                                                    {stepColumns.length > 0 && stepColumns.map(step_column => {
                                                        const step = (usersPerformanceReviewRow.steps || []).find(s =>
                                                            (s.step_id || s.step_name || s.name) ===
                                                            (step_column.step_id || step_column.step_name || step_column.name)
                                                        );
                                                        const stateValue = step ? this.formatStatus(step.state) : "-";
                                                        const ratingValue = step ? this.getRatingLabel(step.rating) : "-";

                                                        const sLower = String(stateValue).toLowerCase();
                                                        let stateBg = "rgba(112, 112, 112, 0.12)";
                                                        let stateColor = "#4a5568";
                                                        if (sLower.includes("completed") || sLower.includes("released") || sLower.includes("published")) {
                                                            stateBg = "rgba(20, 184, 90, 0.12)";
                                                            stateColor = "#15803d";
                                                        } else if (sLower.includes("pending")) {
                                                            stateBg = "rgba(217, 155, 0, 0.12)";
                                                            stateColor = "#b7791f";
                                                        } else if (sLower.includes("progress")) {
                                                            stateBg = "rgba(59, 130, 246, 0.12)";
                                                            stateColor = "#2563eb";
                                                        }

                                                        const hasRating = ratingValue !== "-";

                                                        return (
                                                            <td
                                                                key={step_column.step_id || step_column.step_name || step_column.name}
                                                                className="table-header-text"
                                                                style={{ textAlign: "center", verticalAlign: "middle", minWidth: "180px", padding: "12px 8px" }}
                                                            >
                                                                <div style={{ display: "flex", gap: "6px", alignItems: "center", justifyContent: "center", width: "100%", flexWrap: "wrap" }}>
                                                                    <span style={{
                                                                        color: stateValue !== "-" ? stateColor : "#4a5568",
                                                                        fontSize: "14px",
                                                                        fontWeight: 500
                                                                    }}>
                                                                        {stateValue}
                                                                    </span>
                                                                    <span style={{ color: "#9ca3af", fontSize: "14px", fontWeight: 500 }}>/</span>
                                                                    <span style={{
                                                                        display: "inline-flex",
                                                                        justifyContent: "center",
                                                                        padding: "2px 8px",
                                                                        borderRadius: "6px",
                                                                        backgroundColor: stateBg,
                                                                        color: stateColor,
                                                                        fontSize: "13px",
                                                                        fontWeight: 600,
                                                                        minWidth: "24px"
                                                                    }}>
                                                                        {ratingValue}
                                                                    </span>
                                                                </div>
                                                            </td>
                                                        );
                                                    })}
                                                    <td
                                                        className="table-header-text"
                                                        style={{ textAlign: "center", verticalAlign: "middle" }}
                                                    >
                                                        <span
                                                            style={{
                                                                padding: "6px 14px",
                                                                borderRadius: "999px",
                                                                backgroundColor:
                                                                    usersPerformanceReviewRow.reviewState === "Released"
                                                                        ? "rgba(21, 128, 61, 0.12)"
                                                                        : usersPerformanceReviewRow.reviewState === "Completed" ||
                                                                            usersPerformanceReviewRow.reviewState === "Goal Completed" ||
                                                                            usersPerformanceReviewRow.reviewState === "Published"
                                                                            ? "rgba(20, 184, 90, 0.12)"
                                                                            : usersPerformanceReviewRow.reviewState === "Pending"
                                                                                ? "rgba(217, 155, 0, 0.12)"
                                                                                : usersPerformanceReviewRow.reviewState === "In Progress"
                                                                                    ? "rgba(59, 130, 246, 0.12)"
                                                                                    : "rgba(112, 112, 112, 0.12)",
                                                                color:
                                                                    usersPerformanceReviewRow.reviewState === "Released"
                                                                        ? "rgb(21, 128, 61)"
                                                                        : usersPerformanceReviewRow.reviewState === "Completed" ||
                                                                            usersPerformanceReviewRow.reviewState === "Goal Completed" ||
                                                                            usersPerformanceReviewRow.reviewState === "Published"
                                                                            ? "#15803d"
                                                                            : usersPerformanceReviewRow.reviewState === "Pending"
                                                                                ? "#b7791f"
                                                                                : usersPerformanceReviewRow.reviewState === "In Progress"
                                                                                    ? "#2563eb"
                                                                                    : "#4a5568",

                                                                fontSize: "13px",
                                                                minWidth: "120px",
                                                                display: "inline-block",
                                                                fontWeight: 500
                                                            }}
                                                        >
                                                            {usersPerformanceReviewRow.reviewState}
                                                        </span>
                                                    </td>
                                                    {canReleaseReview && (
                                                        <td
                                                            className="table-header-text"
                                                            style={{ textAlign: "center", verticalAlign: "middle" }}
                                                        >
                                                            {usersPerformanceReviewRow.isReleased ? (
                                                                <span
                                                                    style={{
                                                                        padding: "6px 14px",
                                                                        borderRadius: "999px",
                                                                        backgroundColor: "rgba(21, 128, 61, 0.12)",
                                                                        color: "#15803d",
                                                                        fontSize: "13px",
                                                                        display: "inline-block",
                                                                        minWidth: "90px",
                                                                        fontWeight: 500
                                                                    }}
                                                                >
                                                                    Released
                                                                </span>
                                                            ) : (usersPerformanceReviewRow.reviewState === "Completed" || usersPerformanceReviewRow.reviewState === "Goal Completed") ? (
                                                                <Tooltip content="Release review" portalContainer={document.body}>
                                                                    <Button
                                                                        icon="tick-circle"
                                                                        text="Release"
                                                                        intent="success"
                                                                        small
                                                                        loading={releasingUserId === usersPerformanceReviewRow.userId}
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            this.openReleaseConfirm(usersPerformanceReviewRow.userId);
                                                                        }}
                                                                        disabled={
                                                                            releasingUserId === usersPerformanceReviewRow.userId ||
                                                                            !usersPerformanceReviewRow.userId
                                                                        }
                                                                        style={{
                                                                            minWidth: "90px",
                                                                            borderRadius: "20px",
                                                                            padding: "4px 12px"
                                                                        }}
                                                                    />
                                                                </Tooltip>
                                                            ) : (
                                                                <span style={{
                                                                    display: "inline-block",
                                                                    padding: "6px 14px",
                                                                    borderRadius: "999px",
                                                                    backgroundColor: "rgba(112, 112, 112, 0.08)",
                                                                    color: "#9ca3af",
                                                                    fontWeight: 500,
                                                                    minWidth: "90px",
                                                                    fontSize: "13px"
                                                                }}>-</span>
                                                            )}
                                                        </td>
                                                    )}
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            {!isLoadingUsersPerformanceReview && usersPerformanceReview.length > 0 && totalUsersPerformanceReviewCount > 0 && (
                                <div className="performance-table-footer">
                                    <Flexbox justifyContent="space-between" alignItems="center" flexDirection="row">
                                        <Flexbox justifyContent="flex-end">
                                            <Pagination
                                                activePage={currentPage}
                                                itemsCountPerPage={perPage}
                                                totalItemsCount={totalUsersPerformanceReviewCount}
                                                pageRangeDisplayed={Math.min(5, totalUsersPerformanceReviewPages || 5)}
                                                onChange={this.handleUsersPerformanceReviewPageChange}
                                                disabledClass="bp3-disabled"
                                                innerClass="bp3-button-group bp3-minimal bp3-pagination"
                                                itemClass="bp3-button"
                                                activeClass="bp3-active bp3-pagination-active"
                                                linkClass="no-underline"
                                                prevPageText={<span className="bp3-icon-chevron-left"> </span>}
                                                nextPageText={<span className="bp3-icon-chevron-right"> </span>}
                                                firstPageText={<span className="bp3-icon-double-chevron-left"> </span>}
                                                lastPageText={<span className="bp3-icon-double-chevron-right"> </span>}
                                            />
                                        </Flexbox>
                                        <Flexbox alignItems="center">
                                            <span className="table-header-text" style={{ marginRight: 8 }}>
                                                Show
                                            </span>
                                            <select
                                                value={perPage}
                                                onChange={this.handlePerPageChange}
                                                className="bp3-input"
                                                style={{ width: 80, marginRight: 8 }}
                                            >
                                                {[10, 25, 40, 100].map(size => (
                                                    <option key={size} value={size}>
                                                        {size}
                                                    </option>
                                                ))}
                                            </select>
                                            <span className="table-header-text">per page</span>
                                        </Flexbox>
                                    </Flexbox>
                                </div>
                            )}
                        </div>
                        <ConfirmationDialog
                            isOpen={this.state.showReminderConfirm}
                            onClose={this.closeReminderConfirm}
                            onConfirm={() => {
                                const { reminderTargetUserId } = this.state;
                                if (reminderTargetUserId) {
                                    this.handleSendReminder(reminderTargetUserId);
                                }
                                this.closeReminderConfirm();
                            }}
                            title="Send Reminder"
                            message="Are you sure you want to send a reminder to"
                            itemName="this employee"
                            confirmText="Yes, Send Reminder"
                            confirmIntent="primary"
                            isSubmitting={
                                this.state.sendingReminderUserId === this.state.reminderTargetUserId
                            }
                        />

                        <ConfirmationDialog
                            isOpen={this.state.showReleaseConfirm}
                            onClose={this.closeReleaseConfirm}
                            onConfirm={() => {
                                const { releaseTargetUserId } = this.state;
                                if (releaseTargetUserId) {
                                    this.handleRelease(releaseTargetUserId);
                                }
                                this.closeReleaseConfirm();
                            }}
                            title="Release Review"
                            message="Are you sure you want to release "
                            itemName="this performance review"
                            confirmText="Yes, Release"
                            confirmIntent="success"
                            isSubmitting={
                                this.state.releasingUserId === this.state.releaseTargetUserId
                            }
                        />
                    </Flexbox>
                </ErrorBoundary>
            </ThemeWrapper>
        );
    }
}